import { useEffect, useState } from "react";

const navLinks = [
  { id: "features", label: "平台亮点" },
  { id: "mobile", label: "手机版安装" },
  { id: "tv", label: "TV版安装" },
  { id: "devices", label: "设备适配" },
  { id: "versions", label: "更新日志" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2 cursor-pointer"
          aria-label="星辰影视首页"
        >
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center ${
              scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-movie-2-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold tracking-wide ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            星辰影视
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`text-sm cursor-pointer whitespace-nowrap transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600"
                    : "text-background-100 hover:text-background-50"
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#mobile"
            className="hidden sm:inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm px-4 py-2 rounded-md cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
          >
            <i className="ri-download-2-line"></i>
            立即下载
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开导航菜单"
            aria-expanded={menuOpen}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
              scrolled ? "text-foreground-900" : "text-background-50"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2 rounded-md text-sm text-foreground-800 hover:bg-background-100 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}